<div class="h-100 d-flex align-items-center justify-content-center" style="height: 4.5em !important;">
    <div class="nav-expander" [ngClass]="{'expanded':expanded}">
        <div class="nav-button d-flex align-items-center link" [ngClass]="{'mainColor': navTitle !== '影视'}"
            (click)="toggleMenu()" (mouseenter)="openMenu()" (mouseleave)="hideMenu()">
            <ng-container>
                <div class="text-center flex-1 fs-16 d-flex align-items-center justify-content-end"
                    [ngClass]="{'mainColor': isInDiscovery, 'fw-600': navTitle !== '影视'}" style="white-space: nowrap;">
                    {{ navTitle }}
                    <span class="iconfont iconjiantou_liebiaozhankai margin-adjust fs-24"
                        [ngClass]="{'rotate-180': expanded}"></span>
                </div>
            </ng-container>


        </div>
    </div>
</div>

<div [hidden]="!expanded" class="menu-pop" (mouseenter)="openMenu()" (mouseleave)="hideMenu()"
    [ngClass]="{'two-col':menu?.length > 13, 'flexStyle': expanded}">
    <ng-container>
        <app-box-arrow [colorChange]="true"></app-box-arrow>
        <div class="menu-item">
            <div class="d-flex align-items-center" *ngIf="navType === 'discovery'">
                <a class="w-100" [routerLink]="['/discovery']">推荐</a>
            </div>
        </div>
        <div class="menu-item" *ngFor="let menuItem of menu; let index=index">
            <!-- {{ menuItem | json }} -->
            <div class="mitem" (mouseOverEvent)="onMenuItemHover($event)" [menuItem]="menuItem" [menuItemId]="index"
                [children]="menuItem.submenu.length"></div>
    
            <div class="smitem" *ngIf="menuItem.submenu.length && index === expandedSubmenu" [submenu]="menuItem.submenu">
            </div>
        </div>
    </ng-container>
  
</div>